import { AccessTokenDto } from '@shared/dtos/access-token.dto';
import { UserRoles } from '@shared/enums/user-roles';

export class CurrentUserInfo {
  email: string;
  firstName: string;
  lastName: string;
  userId: string;
  userInitials: string;
  isExternal: boolean;
  isAdmin: boolean;
  isCountryAdmin: boolean;
  roles: string[];

  constructor(accessToken: AccessTokenDto) {
    this.email = accessToken.email;
    this.firstName = accessToken.given_name;
    this.lastName = accessToken.family_name;
    this.userId = accessToken.sub;
    this.userInitials = `${this.firstName[0]}${this.lastName[0]}`;
    this.isExternal = false; //TODO
    this.roles = Array.isArray(accessToken.role)
      ? accessToken.role
      : accessToken.role
        ? [accessToken.role]
        : [];
    this.isAdmin =
      this.roles.includes(UserRoles.GstarAdmin) ||
      this.roles.includes(UserRoles.SystemAdmin);
    this.isCountryAdmin = this.roles.includes(UserRoles.CountryAdmin);
  }
}
